<template>
  <!-- 微信提示用户浏览器打开页面 -->
  <div class="wxTransition">
    <div class="tipBg">
      <img src="@assets/image/independent/wx-tip.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "wxTransition",
  components: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  methods: {}
};
</script>
<style lang='less' scoped>
.wxTransition {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 89;
  .tipBg {
    width: 80%;
    margin: 0 auto;
    margin-top: 2rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>